import axios from "@/lib/axios";

const getOrderHistoryDetail = (id: string | number) => {
  return axios.get(`/facility/order_history/${id}`);
}

export default getOrderHistoryDetail;